/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CopilotUserMetricsRequest extends models.CopilotOrgMetricsRequest {
    getFixupPrototypeFunction() { return CopilotUserMetricsRequest.fixupPrototype; }

    static newInstance(model: Partial<CopilotUserMetricsRequest>): CopilotUserMetricsRequest {
        let obj = Object.assign(new CopilotUserMetricsRequest(), model);
        CopilotUserMetricsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CopilotUserMetricsRequest>): CopilotUserMetricsRequest {
        if (!model) return null;
        return CopilotUserMetricsRequest.newInstance(<CopilotUserMetricsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CopilotUserMetricsRequest) {
        if (!obj) return;

        models.CopilotUserMetricsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CopilotUserMetricsRequest): boolean {
        if (models.CopilotOrgMetricsRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CopilotUserMetricsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
    }

    /**
     * Start date for the metrics range
     */
    start_date: Date;

    /**
     * End date for the metrics range
     */
    end_date: Date;

}
